/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import moment from 'moment';

type PropsType = {
  index: number,
  placement_index: number,
  id: any,
  image_url: string,
  location: string,
  name: string,
  begin_time_utc: any,
  setEventPlacementIndex: () => void
};

const EventCard = (props: PropsType): React.Element<'div'> => {
  const {
    index,
    setEventPlacementIndex,
    id,
    image_url,
    location,
    name,
    begin_time_utc,
    placement_index
  } = props;

  return (
    <div className="col-sm-6">
      <div className="panel panel-default sortable-item" style={{ display: 'block' }}>
        <div className="panel-heading panel-heading-gray">
          <div className="panel-title">&nbsp;</div>
          <div className="panel-actions pull-right">
              <span
                className="panel-action"
                style={{
                  display: 'none'
                }}
                data-bind="click:$root.toogleDisplay.bind($root,$data,$element)"
              >
                <i
                  className="icon icon-eye"
                  title="Hide Event"
                />
              </span>
            &nbsp;
            <span
              className={`panel-action ${index === 0 ? 'disabled' : ''}`}
              data-bind="css:{disabled:($index()==0)},click:$root.moveTop.bind($root,$data,$element)"
              onClick={() => {
                setEventPlacementIndex(id, placement_index - 1);
              }}
            >
              <i className="icon icon-move-up" data-bind="attr:{title:$L.move_to_top}" title="Move to Top" />
            </span>
          </div>
        </div>
        <div className="panel-body" style={{ padding: 0 }}>
          <div data-bind="compose:{model:$root.getEventModel($data)}">
            <div
              className="sparxo-event sparxo-event-card"
              data-view="shared/components/event-card"
              data-active-view="true"
            >
              <div className="sparxo-event-image-warper">
                <div
                  className="sparxo-event-image"
                  data-bind="style:{backgroundImage:'url(\''+image_url+'\')' }"
                  style={{
                    backgroundImage: `url(${image_url})`
                  }}
                />
              </div>
              <div className="sparxo-event-info" data-bind="css:{'hide-event-time-and-date':hide_event_time_and_date}">
                <div className="sparxo-evnet-info-left">
                  <div className="month" data-bind="text:month">
                    {moment(begin_time_utc).format('MMM')}
                  </div>
                  <div className="day" data-bind="text:date">
                    {moment(begin_time_utc).format('DD')}
                  </div>
                </div>
                <div className="sparxo-event-info-right">
                  <div className="name" data-bind="text:name">{name}</div>
                  <div className="time">
                    <i className="icon icon-clock-o" style={{ marginLeft: '1px' }} />
                    <span data-bind="text:time"> {moment(begin_time_utc).format('MMM d hh:mm a')}</span>
                  </div>
                  <div className="addr">
                    <i className="icon icon-location" />
                    <span data-bind="text:location">{location}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventCard;
